import { device1288, device1024, device360, device600, device800, TScreen } from '@ui/hooks/useResize'
type tSize = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12'
export const colSize = (sizes: tSize[], deviceSize: TScreen = device1288) => {
  if (deviceSize === device360) return sizes[0]
  if (deviceSize === device600) return sizes[1]
  if (deviceSize === device800) return sizes[2]
  if (deviceSize === device1024) return sizes[3]
  return sizes[4]
}
